import React from 'react';

import FBieWorkbenchShell, {
  FWorkbenchShellProps,
} from './FBieWorkbenchShell';
import PlanningContextRequired from './PlanningContextRequired';
import { PlanningContextPageProps } from './planningcontext.pageprops.patch';
import { requirePlanningCycle } from './cycle-bound-page.guard';

export interface PlanningWorkbenchShellProps
  extends Omit<
      FWorkbenchShellProps,
      | 'planningContext'
      | 'showPlanningContext'
      | 'onChangePlanningCycle'
      | 'switchingPlanningContext'
      | 'children'
    >,
    PlanningContextPageProps {
  /** Most planning pages are cycle-bound. Planning Control can set this false. */
  requireCycle?: boolean;
  contextRequiredTitle?: string;
  contextRequiredMessage?: string;
  children: React.ReactNode;
}

/**
 * Standard shell for BIE Historical Data through Activity Monitoring.
 *
 * It always renders the workbench chrome and context banner. When a page is
 * cycle-bound and no cycle is selected, only the content area is guarded; the
 * shell, Back, Refresh, alerts and context switch action remain available.
 */
export default class PlanningWorkbenchShell extends React.PureComponent<PlanningWorkbenchShellProps> {
  openPlanningCycleSwitcher = () => {
    if (this.props.openPlanningCycleSwitcher){
      this.props.openPlanningCycleSwitcher();
    }
  }
  public render(): React.ReactNode {
    const {
      plancontext,
      planningContextSwitching,
      openPlanningCycleSwitcher,
      requireCycle = true,
      contextRequiredTitle,
      contextRequiredMessage,
      children,
      ...shellProps
    } = this.props;

    const guard = requirePlanningCycle(plancontext);
    const content = requireCycle && !guard.ready ? (
      <PlanningContextRequired
        title={contextRequiredTitle}
        message={contextRequiredMessage || guard.message}
        onOpenPlanningCycle={this.openPlanningCycleSwitcher}
      />
    ) : (
      children
    );

    return (
      <FBieWorkbenchShell
        {...shellProps}
        planningContext={plancontext}
        showPlanningContext
        onChangePlanningCycle={openPlanningCycleSwitcher}
        switchingPlanningContext={planningContextSwitching}
      >
        {content}
      </FBieWorkbenchShell>
    );
  }
}
